import BaseFormPresenter from "../../../../../components/common/BaseFormPresenter";
import { convertTo12Hour } from "../../../../../components/common/Converter";

class SchedulePresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  convertTimeToHours(timeString) {
    const [hours, minutes] = timeString.split(":").map(Number);
    return hours + minutes / 60; // Convert minutes to a fraction of an hour
  }

  handleAddSchedule(object) {
    const innn = this.convertTimeToHours(this.view.state.timeIn);
    const outtt = this.convertTimeToHours(this.view.state.timeOut);
    let timeDifference = outtt - innn;

    if (timeDifference < 0) {
      timeDifference += 24; // Add 24 hours to adjust for overnight shift
    }
    // schedule object
    const { selectedOption, sequence, startingDate, selectedDay } =
      this.view.state;

    let option = selectedOption;
    // duration checking
    let duration = timeDifference;

    const isForWorking = [
      "4days Working, 2days off",
      "Regular 3days Working, 3days off",
    ].includes(selectedOption);

    // console.log("DURATION: ", duration);
    if (sequence === "10.5 HOURS" && duration < 8) {
      return this.showError("Scheduled duration expect 8 hrs");
    }

    // if (
    //   sequence === "9/12/12.5/13 HOURS" &&
    //   duration < 9
    //   //  &&
    //   // (selectedOption === "Regular" ||
    //   //   selectedOption === "Regular 3days Working, 3days off")
    // ) {
    //   return this.showError("Scheduled duration expect atleast 9 hrs above");
    // }

    if (
      sequence === "24 HOURS" &&
      duration !== 0
      //  &&
      // (selectedOption === "Regular" ||
      //   selectedOption === "Regular 3days Working, 3days off")
    ) {
      return this.showError("Scheduled duration expect 24 hrs");
    }
    if (duration === 0) {
      duration = 24;
      option = "Graveyard";
    }

    let updateDay = selectedDay;
    if (
      sequence !== "10.5 HOURS" &&
      ["Graveyard", ""].includes(selectedOption)
    ) {
      // const nextDayMap = {
      //   Sunday: "Monday",
      //   Monday: "Tuesday",
      //   Tuesday: "Wednesday",
      //   Wednesday: "Thursday",
      //   Thursday: "Friday",
      //   Friday: "Saturday",
      //   Saturday: "Sunday",
      // };
      // updateDay = `${selectedDay} - ${nextDayMap[selectedDay]}`;
      updateDay = selectedDay;
    }

    if (
      [
        "Regular 3days Working, 3days off",
        "4days Working, 2days off",
        "Graveyard 3days Working, 3days off",
        "Graveyard 4days Working, 2days off",
        "Regular 4days Working, 2days off",
      ].includes(selectedOption)
    ) {
      updateDay = selectedOption;
    }
    // if (!this.view.state.sequence) {
    //   return this.showError("Sequence required!");
    // }
    // if (innn === 0) {
    //   return this.showError("Time-in required!");
    // }

    // if (
    //   (selectedOption === "Specific Day" ||
    //     selectedOption === "4days Working, 2days off") &&
    //   this.view.state.selectedDay === ""
    // ) {
    //   return this.showError("Select Specific Day.");
    // }

    // if (isForWorking && !this.view.state.startingDate) {
    //   return this.showError("Date required!");
    // }

    // if (!sequence) return this.showError("Sequence required!");
    // if (!selectedOption && sequence === "10.5 HOURS")
    //   return this.showError("Option required!");
    // if (
    //   (["Specific Day", "4days Working, 2days off"].includes(selectedOption) ||
    //     ["9/12/12.5/13 HOURS", "24 HOURS"].includes(sequence)) &&
    //   !selectedDay
    // )
    //   return this.showError("Select Specific Day.");
    // if (!innn) return this.showError("Time-in required!");
    // if (duration < 0) return this.showError("Time-in is greater than Time-out");
    // if (isForWorking && !startingDate) return this.showError("Date required!");

    let schedules = isForWorking ? [] : [...this.view.props.schedules]; // Clone existing schedules

    const generateSchedules = (days) => {
      return days.map((day) => {
        const existingIndex = schedules.findIndex((s) => s.day === day);
        const newSchedule = {
          ...object,
          timein: this.view.state.timeIn ? this.view.state.timeIn : "",
          timeout: this.view.state.timeOut ? this.view.state.timeOut : "",
          lateTimeIn: this.view.state.lateTimeIn,
          earliestTimeOut: this.view.state.earliestTimeOut,
          day: day || "",
          duration: duration ? `${duration.toFixed(2)} hrs` : "",
        };

        if (existingIndex !== -1) {
          // Update existing schedule for the day
          schedules[existingIndex] = newSchedule;
        } else {
          // Add new schedule if it doesn't exist
          schedules.push(newSchedule);
        }

        return newSchedule;
      });
    };

    switch (selectedOption) {
      case "Daily (M-F)":
        generateSchedules([
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
        ]);
        break;
      case "Alternate (MWF)":
        generateSchedules(["Monday", "Wednesday", "Friday"]);
        break;
      case "Alternate (TTHS)":
        generateSchedules(["Tuesday", "Thursday", "Saturday"]);
        break;
      case "Weekend (Sat-Sun)":
        generateSchedules(["Saturday", "Sunday"]);
        break;
      default:
        generateSchedules([updateDay]);
        break;
    }

    this.view.props.scheduleTableData(schedules);
    this.view.props.scheduleObject({
      selectedOption: option,
      startingDate,
      sequence,
    });
    this.view.props.isAddBtnClick(true);
  }
}

export default SchedulePresenter;
